import React, { useEffect, useState } from 'react';

const CustomMassageItem = ({title, text, onTextChange, onDelete }) => {
    return (
        <div className='custom_massage_item_wrap'>
            <p>Rule {title}</p>
            <div className='custom_massage_item_text'>
                <img src="/img/Menu.svg" alt="" />
                <textarea name="" id="" value={text} onChange={(e) => onTextChange(e.target.value)}></textarea>
                <div className='custom_massage_item_text_img'>
                    <img src="/img/Close.svg" alt="" onClick={onDelete} />
                </div>
            </div>
        </div>
    );
};

export default CustomMassageItem;